import { useRef } from 'react';

import {
  HelpCircleIcon,
  Logout02Icon,
  Settings02Icon,
  UserMultiple02Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { Permissions } from 'constants/permissions';
import { useAccessControl } from 'hooks/access-control';
import { useClickOutside } from 'hooks/click-outside';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { selectPermissions } from 'api/user-permissions-slice';

import styles from './ProfileCard.module.scss';

export const ProfileCard = ({
  user,
  visible = false,
  onClose = () => {},
  onSignOut = () => {},
}) => {
  const wrapperRef = useRef(null);

  const permissions = useSelector(selectPermissions);
  const hasAccess = useAccessControl(permissions);

  useClickOutside(wrapperRef, onClose);

  return (
    <div className={cn(styles.root, { [styles.rootHidden]: !visible })} ref={wrapperRef}>
      <div className="d-flex u-margin">
        <div className={styles.info}>
          <p className={styles.userName}>{user.name}</p>
          <p className={styles.userEmail}>{user.email}</p>
          <Link to="/account/profile" className={styles.accountBtn}>
            View Account
          </Link>
        </div>
      </div>
      <hr />
      <div className={styles.linksWrapper}>
        {hasAccess(Permissions.CompanyWrite) && (
          <Link to="/company" className={styles.link}>
            <HugeiconsIcon icon={Settings02Icon} strokeWidth="2" />
            Company Settings
          </Link>
        )}
        {hasAccess(Permissions.CompanyWrite) && (
          <Link to="/users" className={styles.link}>
            <HugeiconsIcon icon={UserMultiple02Icon} strokeWidth="2" />
            User Access
          </Link>
        )}
        <a href="https://help.checkmate.tech/en/" target="_blank" className={styles.link}>
          <HugeiconsIcon icon={HelpCircleIcon} strokeWidth="2" />
          Support
        </a>
        <a className={styles.link} onClick={onSignOut}>
          <HugeiconsIcon icon={Logout02Icon} strokeWidth="2" />
          Sign Out
        </a>
      </div>
    </div>
  );
};
